<template>
 <svg
    enable-background="new 0 0 720 720"
    height="720px"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 1024 1024"
    width="720px"
   
  >
    <path
      d="M808.817,0H394.076L145.071,249.004v704.225c0,39.023,31.452,70.771,70.111,70.771h593.635  c38.66,0,70.111-31.748,70.111-70.771V70.772C878.929,31.748,847.478,0,808.817,0z M854.753,953.229  c0,25.566-20.607,46.367-45.936,46.367H215.183c-25.328,0-45.935-20.801-45.935-46.367V249.004h164.828c33,0,60-27,60-60v-164.6  h414.741c25.328,0,45.936,20.801,45.936,46.368V953.229z"
      fill="#C0392B"
    />
    <g>
      <path
        d="M80,670.833h65.071V585l-70.946,88.375h0.012C75.337,671.805,77.368,670.833,80,670.833z"
        fill="#262626"
      />
      <path
        d="M944,670.833h-65.071V585l70.946,88.375h-0.012C948.663,671.805,946.632,670.833,944,670.833z"
        fill="#262626"
      />
      <path
        d="M882.443,861.471c-1.934,5.149-8.015,9.362-13.515,9.362H155.071c-5.5,0-11.582-4.213-13.515-9.362   L73.514,680.195c-1.933-5.149,0.986-9.362,6.486-9.362h864c5.5,0,8.419,4.213,6.486,9.362L882.443,861.471z"
        fill="#C0392B"
      />
    </g>
    <g>
      <path
        d="M335.251,818.323c0-5.013,1.484-8.881,4.454-11.606c2.97-2.724,7.287-4.087,12.955-4.087   c5.395,0,9.535,1.363,12.424,4.087c2.888,2.726,4.332,6.594,4.332,11.606c0,4.903-1.485,8.732-4.455,11.483   c-2.971,2.751-7.069,4.127-12.301,4.127c-5.395,0-9.645-1.362-12.75-4.086C336.804,827.123,335.251,823.282,335.251,818.323z"
        fill="#FFFFFF"
      />
      <path
        d="M476.241,750.402c0,13.351-3.938,23.662-11.811,30.937c-7.874,7.273-19.058,10.911-33.552,10.911h-9.072   v39.641h-32.284V712.396h41.356c15.093,0,26.427,3.297,34.001,9.89C472.453,728.88,476.241,738.252,476.241,750.402z    M421.807,765.932h5.885c4.85,0,8.705-1.361,11.565-4.087c2.86-2.724,4.291-6.483,4.291-11.279c0-8.063-4.469-12.097-13.404-12.097   h-8.337V765.932z"
        fill="#FFFFFF"
      />
      <path
        d="M596.716,769.609c0,19.943-5.488,35.31-16.469,46.098c-10.98,10.789-26.414,16.184-46.302,16.184h-38.66   V712.396h41.357c19.179,0,33.987,4.903,44.423,14.712C591.499,736.916,596.716,751.084,596.716,769.609z M563.206,770.754   c0-10.952-2.166-19.07-6.498-24.356c-4.332-5.285-10.912-7.929-19.738-7.929h-9.399v66.94h7.192c9.809,0,17-2.847,21.578-8.541   C560.917,791.175,563.206,782.47,563.206,770.754z"
        fill="#FFFFFF"
      />
      <path
        d="M649.925,831.891h-31.793V712.396h70.617v25.909h-38.824v22.804h35.801v25.909h-35.801V831.891z"
        fill="#FFFFFF"
      />
    </g>
    <g>
      <g>
        <g>
          <path
            d="M729.983,369.821c0,8.25-9,15-20,15H314.852c-11,0-20-6.75-20-15s9-15,20-15h395.132     C720.983,354.821,729.983,361.571,729.983,369.821z"
            fill="#C0392B"
          />
        </g>
        <g>
          <path
            d="M729.148,459.821c0,8.25-9,15-20,15H314.017c-11,0-20-6.75-20-15s9-15,20-15h395.132     C720.148,444.821,729.148,451.571,729.148,459.821z"
            fill="#C0392B"
          />
        </g>
        <g>
          <path
            d="M729.983,550.016c0,8.25-9,15-20,15H314.852c-11,0-20-6.75-20-15s9-15,20-15h395.132     C720.983,535.016,729.983,541.766,729.983,550.016z"
            fill="#C0392B"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
